import React, { Fragment, useEffect, useState } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Header from "../InitialPage/Sidebar/Header";
import Sidebar from "../InitialPage/Sidebar/Sidebar";
import { authRoute, publicRoutes } from "./router.link";
import { Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { ToasterContainer } from "../feature-module/components/toaster/Toaster";
import { all_routes } from "./all_routes";
import ProfileBanner from "../feature-module/components/ProfileBanner";
import { createTheme, ThemeProvider } from "@mui/material";

const AllRoutes = () => {

  const routes = all_routes;

  let theme = createTheme();
  theme = createTheme({
    palette: {
      primary: {
        main: "#2D4F8F",
        contrastText: "#fff",
      },
      secondary: {
        main: "#092C4C",
        contrastText: "#fff",
      },
    },
    typography: {
      fontFamily: "Nunito, sans-serif",
    },
  });

  const { toggleHeader, userData } = useSelector((state) => {
    return {
      toggleHeader: state.toggle_header,
      userData: state.user_detail
    }
  });

  const [routesState, setRoutesState] = useState([]);

  const HeaderLayout = ({ sidebar }) => (
    <div className={`main-wrapper ${toggleHeader ? "header-collapse" : ""}`}>
      {/* <Loader /> */}
      <Header />
      <Sidebar sidebar={sidebar} />
      <ProfileBanner />
      <Outlet />
    </div>
  );

  const Authpages = () => (
    <div className={toggleHeader ? "header-collapse" : ""}>
      <Outlet />
      {/* <Loader /> */}
    </div>
  );

  const normalizeModule = (module) => module.replace(/\s+/g, '_');

  const hasPermission = (requiredPermissions, userPermissions) => {
    if (requiredPermissions?.includes("All")) return true;
    return requiredPermissions?.includes(userPermissions);
  };

  const filterRoute = (routesArray, userPermissions) => {
    return routesArray
      .map((route) => {
        const filteredSubmenuItems = route.submenuItems.filter((item) => hasPermission(item.permissions, userPermissions || ""));

        if (filteredSubmenuItems.length > 0) {
          return { ...route, submenuItems: filteredSubmenuItems };
        }

        return null;
      })
      .filter(Boolean);
  };

  useEffect(() => {
    setRoutesState(filterRoute(publicRoutes, userData?.role));
  }, [userData]);

  return (
    <ThemeProvider theme={theme}>

      {/* ========== Toaster ========== */}
      <ToasterContainer />

      <Routes>

        <Route path={"/"} element={userData?.access_token ? <HeaderLayout sidebar={routesState} /> : <Navigate to={routes?.signin} />}>
          {routesState.map((route, id) => (
            <Fragment key={id}>
              {route?.submenuItems.length > 0 && route?.submenuItems.map((item, index) => (
                <Route path={item.path} element={item.element} key={`${id}${index}`} />
              ))}
            </Fragment>
          ))}
        </Route>

        <Route path={"/"} element={userData?.access_token ? <Navigate to={routes?.dashboard} /> : <Authpages />}>
          {authRoute.map((route, id) => (
            <Route path={route.path} element={route.element} key={id} />
          ))}
        </Route>

      </Routes>
    </ThemeProvider>
  );
};
export default AllRoutes;
